export const COLOR = "color";
export const BLACK = "black";
export const COLLATE_WITH_CALENDAR = "collate with calendar";
export const SHIP_FLAT_WITH_CALENDAR = "ship flat with calendar";
